<template>
    <modal
        id="billing-details-modal"
        :centered="true"
        :title="$t('checkout.billingDetailsModalTitle')"
        :show="modal.show"
        :close="modal.close"
        :closeable="modal.closeable"
        @modal-invisible="modal.show = modal.close = false"
        @modal-close="onClose"
        size="modal-lg"
    >
        <form
            action=""
            method="post"
            ref="billingDetailsForm"
            class="modal-body"
            @submit.prevent="onSubmit"
        >
            <div class="row">
                <div class="col-12 col-md-6">
                    <div class="form-group">
                        <label for="first_name">
                            {{ $t('shop.first_name') }}
                        </label>
                        <input
                            type="text"
                            name="first_name"
                            class="form-control"
                            id="first_name"
                            :placeholder="$t('shop.first_name_placeholder')"
                            :class="{ 'is-invalid': formErrors.first_name }"
                            v-model="first_name"
                            required
                        />
                        <div class="invalid-feedback">
                        <span
                            class="d-block"
                            v-for="error in formErrors.first_name"
                            :key="error"
                        >{{ error }}</span>
                        </div>
                    </div>
                </div>
                <div class="col-12 col-md-6">
                    <div class="form-group">
                        <label for="last_name">
                            {{ $t('shop.last_name') }}
                        </label>
                        <input
                            type="text"
                            name="last_name"
                            class="form-control"
                            id="last_name"
                            :placeholder="$t('shop.last_name_placeholder')"
                            :class="{ 'is-invalid': formErrors.last_name }"
                            v-model="last_name"
                            required
                        />
                        <div class="invalid-feedback">
                            <span
                                class="d-block"
                                v-for="error in formErrors.last_name"
                                :key="error"
                            >
                                {{ error }}
                            </span>
                        </div>
                    </div>
                </div>
                <div class="col-12 col-md-8">
                    <div class="form-group">
                        <label for="street">
                            {{ $t('shop.street') }}
                        </label>
                        <input
                            type="text"
                            name="street"
                            class="form-control"
                            id="street"
                            :placeholder="$t('shop.street_placeholder')"
                            :class="{ 'is-invalid': formErrors.street }"
                            v-model="street"
                            required
                        />
                        <div class="invalid-feedback">
                            <span class="d-block" v-for="error in formErrors.street" :key="error">
                                {{ error }}
                            </span>
                        </div>
                    </div>
                </div>
                <div class="col-12 col-md-4">
                    <div class="form-group">
                        <label for="house">
                            {{ $t('shop.house_number') }}
                        </label>
                        <input
                            type="text"
                            name="house"
                            class="form-control"
                            id="house"
                            :placeholder="$t('shop.house_number_placeholder')"
                            :class="{ 'is-invalid': formErrors.house }"
                            v-model="house"
                            required
                        />
                        <div class="invalid-feedback">
                            <span class="d-block" v-for="error in formErrors.house" :key="error">
                                {{ error }}
                            </span>
                        </div>
                    </div>
                </div>
                <div class="col-12 col-md-4">
                    <div class="form-group">
                        <label for="postcode">
                            {{ $t('shop.postcode') }}
                        </label>
                        <input
                            type="text"
                            name="postcode"
                            class="form-control"
                            id="postcode"
                            :placeholder="$t('shop.postcode_placeholder')"
                            :class="{ 'is-invalid': formErrors.postcode }"
                            v-model="postcode"
                            required
                        />
                        <div class="invalid-feedback">
                            <span
                                class="d-block"
                                v-for="error in formErrors.postcode"
                                :key="error"
                            >{{ error }}</span>
                        </div>
                    </div>
                </div>
                <div class="col-12 col-md-8">
                    <div class="form-group">
                        <label for="city">
                            {{ $t('shop.city') }}
                        </label>
                        <input
                            type="text"
                            name="city"
                            class="form-control"
                            id="city"
                            :placeholder="$t('shop.city_placeholder')"
                            :class="{ 'is-invalid': formErrors.city }"
                            v-model="city"
                            required
                        />
                        <div class="invalid-feedback">
                            <span class="d-block" v-for="error in formErrors.city" :key="error">
                                {{ error }}
                            </span>
                        </div>
                    </div>
                </div>
                <div class="col-12">
                    <div class="form-group">
                        <label for="country">
                            {{ $t('shop.country') }}
                        </label>
                        <select
                            name="country"
                            id="country"
                            :class="{ 'is-invalid': formErrors.country }"
                            class="form-control"
                            v-model="country"
                            required
                        >
                            <option disabled value="false" selected>
                                {{ $t('shop.dropdown_required') }}
                            </option>
                            <option
                                v-for="templateOption in countries"
                                :key="templateOption.country_name"
                                :value="templateOption.country_name"
                            >
                                {{ $t('country.' + templateOption.country_code) }}
                            </option>
                        </select>
                        <div class="invalid-feedback">
                            <span
                                class="d-block"
                                v-for="error in formErrors.country"
                                :key="error"
                            >{{ error }}</span
                            >
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-12 text-center">
                    <div class="spinner">
                    </div>
                    <button
                        v-if="!isOngoing"
                        class="btn btn-primary"
                        :disabled="formComplete"
                        @click="
                            $event.preventDefault();
                            onSubmit();
                        "
                    >
                        {{ $t('checkout.billingDetailsModalForward') }}
                    </button>
                </div>
            </div>
            <div class="row mt-2 p-3" v-if="isOngoing">
                <div class="col-12 text-center">
                    <loading-animation
                        :visible="isOngoing"
                        :always-show="false"
                        preloader-container-id=""
                        status-container-id=""
                    ></loading-animation>
                </div>
            </div>
        </form>
    </modal>
</template>

<script>
export default {
    name: 'BillingDetailsModal',

    props: {
        countries: {
            type: Array,
            required: true,
        },
        previousFirstName: {
            type: String,
            required: false,
            default() {
                return null;
            },
        },
        previousLastName: {
            type: String,
            required: false,
            default() {
                return null;
            },
        },
        order: {
            type: Object,
            required: true,
        },
    },

    data() {
        return {
            modal: {
                show: false,
                close: true,
                closeable: true,
            },
            formErrors: {},
            isOngoing: false,
            formComplete: false,
            first_name: null,
            last_name: null,
            street: null,
            house: null,
            postcode: null,
            city: null,
            country: false,
        };
    },

    watch: {
        isOngoing(val) {
            if (!this.formComplete) {
                this.modal.closeable = !val;
            }
        },

        previousFirstName(val) {
            this.first_name = val;
        },

        previousLastName(val) {
            this.last_name = val;
        },
    },

    methods: {
        showModal() {
            this.modal.close = false;
            this.modal.show = true;
        },

        hideModal() {
            if (!this.modal.show) {
                return;
            }

            this.modal.closeable = true;
            this.$nextTick(() => {
                this.modal.close = true;
            });
        },

        onClose() {
            this.formErrors = {};
        },

        onSubmit() {
            this.formErrors = {};

            if (this.isOngoing && this.formComplete) {
                return;
            }

            this.isOngoing = true;

            axios.post(
                '/' + this.$language + '/backend/validate/billing-details/' + this.order.hash,
                (new FormData(this.$refs.billingDetailsForm))
            ).then(() => {
                this.formComplete = true;

                setTimeout(() => {
                    this.$emit('billing-data-filled');
                }, 800);
            }).catch((error) => {
                this.formErrors = error.response.data.errors;
            }).finally(() => {
                this.isOngoing = false;
            });
        },
    },
};
</script>

<style lang="scss">
#billing-details-modal {
    .modal-body {
        overflow-y: auto;
    }

    .loader-container {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        z-index: 9999999;

        background: rgba(255, 255, 255, 0.8);
    }
    .loader-container .preloader .status {
        position: absolute;
        top: 50%;
        left: 0;
        right: 0;
        -webkit-transform: translateY(-50%);
        transform: translateY(-50%);
    }

    .modal-title {
        margin-block: auto;
    }
}
</style>
